<template>
  <div class="container" :style="{'background-image': 'url('+loginbg+')'}">
    <div class="forms-container">
      <div class="signin-signup">
        <form action="" class="sign-in-form">
          <h2 class="title" style="color: #FFFFFF">{{systemTitle}}</h2>
          <div class="input-field">
            <i class="fa fa-user"></i>
            <input type="text" v-model="loginForm.username" placeholder="用户手机号">
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" v-model="loginForm.password" placeholder="密码">
          </div>
          <div v-show="loginForm.errorVisible" style="color: #cccccc">
            {{ loginForm.errorMsg }}
          </div>

          <el-row :gutter="20">
            <el-col :span="24">
              <input type="button" @click="userpwdLogin" value="登 录" class="btn solid">
            </el-col>
          </el-row>
          <el-row :gutter="20" type=“flex” align="middle" style="width: 100%;max-width: 300px;text-align: right;">
            <el-col :span="8" style=" position: relative;top:50%;transform:translateY(-50%);">
              <el-checkbox label="记住密码" v-model="remenberPasswordchecked" @change="rembpwdCheckedChange"></el-checkbox>
            </el-col>
            <el-col :span="8">
              <el-button type="text" @click="userRegister" :disabled="isBusiness">立即注册</el-button>
            </el-col>
            <el-col :span="8">
              <el-button type="text" @click="forgetPwd">忘记密码</el-button>
            </el-col>
          </el-row>
        </form>
<!--
        <form action="" class="sign-up-form">
          <h2 class="title">用户注册</h2>
          <div class="input-field">
            <i class="fa fa-share-alt"></i>
            <input type="text" v-model="registerUserForm.shareCode" placeholder="share code">
          </div>
          <div class="input-field">
            <i class="fa fa-user"></i>
            <input type="text" v-model="registerUserForm.userName" placeholder="Username">
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" v-model="registerUserForm.userPassword" placeholder="password">
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" v-model="registerUserForm.conformPassword" placeholder="conformPassword">
          </div>
          <div class="input-field">
            <i class="fa fa-user"></i>
            <input type="text" v-model="registerUserForm.userPhone" placeholder="userPhoneNum">
          </div>
          <div class="input-field">
            <i class="fa fa-user"></i>
            <select v-model="registerUserForm.userType" style="max-width: 230px">
              <option v-for="item in userTypeSelectOpt" :key="item">{{ item }}</option>
            </select>
          </div>
          //<div class="input-field">
            <i class="fa fa-envelope"></i>
            <input type="text" placeholder="Email">
          </div>//
          <div v-show="registerUserForm.errorVisible">
            {{ registerUserForm.errorMsg }}
          </div>
          <input type="button" @click="userRegister" value="注 册" class="btn solid">
        </form>
        -->
      </div>
<!--
      <div class="panels-container">
        <div class="panel left-panel">
          <div class="content">
            <h3>新用户注册</h3>
            <p>B2c 商务管理系统是一个使用Spring Boot、Spring Security(JWT)、Vue开发的前后端分离的商务管理框架.</p>
            <button class="btn transparent" id="sign-up-btn">去注册</button>
          </div>

          <img src="../assets/img/log.svg" class="image" alt="">
        </div>

        <div class="panel right-panel">
          <div class="content">
            <h3>已经注册过？</h3>
            <p>欢迎你注册使用B2c商务管理系统，一起创造美好生活.</p>
            <button class="btn transparent" id="sign-in-btn">去登陆</button>
          </div>

          <img src="../assets/img/register.svg" class="image" alt="">
        </div>
      </div>
      -->
    </div>
    <!--
        <el-dialog
            title="扫描二维码"
            :visible.sync="dialogVisible"
            width="20%">
          <span>关注公众号，回复'dongbb'，字母哥所有资源均在此首发</span>
          <img src="../assets/img/wx-zimug-ketang.png" style="height: 200px;">
          <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
              </span>
        </el-dialog>

        <el-dialog
            title="注册成功"
            :visible.sync="registDialogVisible"
            width="30%"
            center>
          <span>注册成功， 是否登录</span>
          <span slot="footer" class="dialog-footer">
             <el-button @click="registDialogVisible = false">取 消</el-button>
             <el-button type="primary" @click="userpwdLogin">确 定</el-button>
          </span>
        </el-dialog>
        -->
    <div class="videoContainer">
      <video class="fullscreenVideo" id="bgVid" playsinline="" autoplay="" muted="" loop="" width="100%" v-show="videoBgSwitch">
        <source src="../assets/video/tlzbg.mp4" type="video/mp4">
      </video>
    </div>
  </div>

</template>

<script>
import {setJwtToken} from '@/lib/utils'
import {login} from '@/api/system/sys_user'
import {queryLoginBackgroundImage, queryOwnerNameWithDomain} from "../api/b2cbusiness/b2c_websetting";
import * as Utils from "../lib/utils";

export default {
  name: "login",
  data() {
    return {
      systemTitle:"推客-管理系统",
      userTypeSelectOpt: [
        "管理员",
        "业务员",
        "商家",
        "主播",
        "试客"
      ],
      roleCode: "admin",
      loginForm: {
        username: "",
        password: "",
        errorMsg: "",
        errorVisible: false
      },
      registerUserForm: {
        userName: "",
        userPassword: "",
        conformPassword: "",
        userType: "",
        userPhone:"",
        errorMsg: "",
        errorVisible: false
      },
      registDialogVisible:false,
      remenberPasswordchecked:false,
      videoBgSwitch:true,
      isBusiness:false,
      loginbg:require('@/assets/img/bglogin.jpeg'),
      dialogVisible: false
    };
  },
  created() {
    this.registerUserForm.userType = this.userTypeSelectOpt[0];
  },
  mounted() {
      //if (this.$store.state.ws != null){
      //  this.$store.state.ws.close();
      //}
      //window.onload = function () {
      //const sign_in_btn = document.querySelector("#sign-in-btn");
      //const sign_up_btn = document.querySelector("#sign-up-btn");
      const container = document.querySelector(".container");

    if (window.location.hostname == "admin.taoxibao.fit"){
      this.isBusiness = true;
      this.roleCode="admin";
    }else if (window.location.pathname == "/salesman" || window.location.hostname=="dl.taoxibao.fit"){
      this.isBusiness = true;
      this.systemTitle = "推客-业务系统"
      this.roleCode = "salesman"
    }else{
      this.systemTitle = "推客-商家系统"
      this.roleCode = "business"
      this.isBusiness = false;
    }

    //测试用，正式环境需要注释掉
    //this.roleCode = "salesman";

    if (!Utils.isStrEmpty(localStorage.getItem("password"))){
      this.remenberPasswordchecked = true;
      this.loginForm.username = localStorage.getItem("username");
      this.loginForm.password = Utils.decryptPassword(localStorage.getItem("password"));
      console.log(this.loginForm)
    }

      //sign_up_btn.addEventListener('click', () => {
      //  container.classList.add("sign-up-mode");
      //})

      //sign_in_btn.addEventListener('click', () => {
      //  container.classList.remove("sign-up-mode");
     // })
    //}
    if (this.$route.query.sharecode != null){
      this.registerUserForm.shareCode = this.$route.query.sharecode;
      console.log(this.registerUserForm)
      container.classList.add("sign-up-mode");
      this.$forceUpdate()
    }
  },
  methods: {
    rembpwdCheckedChange(val){
      this.remenberPasswordchecked = val;
      if (this.remenberPasswordchecked){
        console.log(this.loginForm)
        localStorage.setItem("username", this.loginForm.username);
        localStorage.setItem("password", Utils.encryptPassword(this.loginForm.password));
      }else{
        localStorage.removeItem("password");
        this.loginForm.password = "";
      }
    },
    forgetPwd(){
      this.$router.push({name:'forgetpwd'});
    },
    userpwdLogin() {
      this.registDialogVisible = false;
      login(this.loginForm.username,
          this.loginForm.password,
          this.roleCode
      ).then(res => {
        setJwtToken(res.data)
        this.$router.push({path: "/home"})
      }).catch(err => {
        this.loginForm.errorMsg = err.message;
        this.loginForm.errorVisible = true;
      });
    },
    userRegister() {
      if (window.location.hostname == "admin.taoxibao.fit" ){
        this.isBusiness = true;
        this.roleCode = "admin";
      }else if (window.location.pathname == "/salesman" || window.location.hostname=="dl.taoxibao.fit"){
        this.isBusiness = true;
        this.systemTitle = "推客-业务系统"
        this.roleCode = "salesman"
      }else{
        this.systemTitle = "推客-商家系统"
        this.roleCode = "business"
        this.isBusiness = false;
        this.$router.push({name:'register'})
      }
      /*
      validatePhone(this.registerUserForm.userPhone, function (val){
        if (!val){
          this.registerUserForm.errorMsg = "请输入正确手机号码";
          this.registerUserForm.errorVisible = true;
        }
      });
      if (this.registerUserForm.userPassword !== this.registerUserForm.conformPassword) {
        this.registerUserForm.errorMsg = "两次输入的密码不一致！请重新输入";
        this.registerUserForm.errorVisible = true;
      }else{
        registerUser(this.registerUserForm).then(res => {
          this.registDialogVisible = true;
          this.loginForm.username = this.registerUserForm.userName;
          this.loginForm.password = this.registerUserForm.userPassword;
        }).catch(err => {
          this.registerUserForm.errorMsg = err.message;
          this.registerUserForm.errorVisible = true;
        });
      }

       */
    }
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      if (vm.$route.query.username != null && vm.$route.query.password != null){
        vm.loginForm = vm.$route.query;
        vm.userpwdLogin();
      }
      queryOwnerNameWithDomain(window.location.hostname).then(res=>{
        if (res.success && res.data != null){
          let subString = "商家系统";
          if (window.location.pathname == "/salesman"){
            subString = "业务系统";
          }
          document.title = res.data;
          vm.systemTitle = res.data + "-" + subString;
        }
      });
      queryLoginBackgroundImage(window.location.hostname).then(res=>{
        if (res.success && res.data != null){
          vm.videoBgSwitch = false;
          vm.loginbg = res.data;
          vm.$forceUpdate();
        }else{
          vm.loginbg = require('@/assets/img/bglogin.jpeg');
        }
      });
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* google字体库 */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, input {
  font-family: 'Poppins', sans-serif;
}

.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.container::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  /*
  border-radius: 50%;
  background: linear-gradient(-45deg, #4481eb, #04befe);
  top: -10%;
  right: 48%;
  transform: translateY(-50%);

  background-color: rgba(0,0,0,.3);
  */
  z-index: 4;
  transition: 1.8s ease-in-out;
}

.videoContainer{
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.videoContainer:before{
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  z-index: -1;
  top: 0;
  left: 0;
  background: rgba(25,29,34,.35);
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

}

.signin-signup {
  position: absolute;
  top: 50%;
  left: 75%;
  /* 作用是什么 */
  transform: translate(-50%, -50%);
  width: 50%;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 5;
  transition: 1s 0.7s ease-in-out;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 5rem;
  overflow: hidden;
  /* 难点 */
  grid-column: 1 / 2;
  grid-row: 1 / 2;

  /* delay防止表单提前暴露 */
  transition: 0.2s 0.7s ease-in-out;
}

form.sign-in-form {
  .el-checkbox{
    color: #FFFFFF;
  }
  z-index: 2;
}

form.sign-up-form {
  z-index: 1;
  opacity: 0;
}

.title {
  font-size: 2.2rem;
  color: #444;
  margin-bottom: 10px;
}

.input-field {
  max-width: 300px;
  width: 100%;
  height: 55px;
  background-color: #FFFFFF;
  margin: 10px 0;
  border-radius: 0px;
  display: grid;
  grid-template-columns: 15% 85%;
  padding: 0 .4rem;
}

.input-field select {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #aaa;
}

.input-field i {
  text-align: center;
  line-height: 55px;
  color: #acacac;
  font-size: 1.1rem;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}

.input-field input::placeholder {
  color: #aaa;
  font-weight: 500;
}

.btn {
  width: 300px;
  height: 44px;
  border: none;
  outline: none;
  border-radius: 0px;
  cursor: pointer;
  background-color: #5995fd;
  color: #fff;
  /* 大写 */
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  /* 动画延迟 */
  transition: .5s;
}

.btn:hover {
  background-color: #4d84e2;
}

.social-text {
  padding: .7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 40px;
  width: 40px;
  border: 1px solid #333;
  margin: 0 0.45rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 1.1rem;
  border-radius: 50%;
  transition: 0.3s;
}

.social-icon:hover {
  color: #4481eb;
  border-color: #44b1eb;
}

.panels-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: center;
  justify-content: center;
  z-index: 7;
}

.panel .content {
  color: #fff;
  transition: .9s .6s ease-in-out;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}

.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.image {
  width: 100%;
  transition: 1.1s .4s ease-in-out;
}

.right-panel .content, .right-panel .image {
  transform: translateX(800px);
}

.container.sign-up-mode:before {
  transform: translate(100%, -50%);
  right: 52%;
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .right-panel .content,
.container.sign-up-mode .right-panel .image {
  transform: translateX(0px);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}

.container.sign-up-mode .signin-signup {
  left: 25%;
}

.container.sign-up-mode form.sign-in-form {
  z-index: 1;
  opacity: 0;
}

.container.sign-up-mode form.sign-up-form {
  z-index: 2;
  opacity: 1;
}

@media(max-width: 870px) {
  .container {
    min-height: 800px;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .container:before {
    width: 1500px;
    height: 1500px;
    left: 30%;
    bottom: 68%;
    transform: translateX(-50%);
    right: initial;
    top: initial;
    transition: 2s ease-in-out;
    z-index: -1;
  }

  .signin-signup {
    width: 100%;
    left: 50%;
    top: 85%;
    transform: translate(-50%, -100%);
    transition: 1s 0.8s ease-in-out;
  }

  .panels-container {

    z-index: 10;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
  }

  .image {
    width: 200px;
    transition: 0.9s 0.6s ease-in-out;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .btn.btn.transparent {
    width: 110px;
    height: 35px;
    font-variation-settings: 0.7rem;
  }

  .panel .content {
    padding-right: 15%;
    transition: 0.9s 0.8s ease-in-out;
  }

  .right-panel .content, .right-panel .image {
    transform: translateY(300px);
  }

  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .container.sign-up-mode .signin-signup {
    top: 5%;
    transform: translate(-50%, 0);
    left: 50%;
  }
}

@media (max-width: 465px) {
  form {
    padding: 0 1.5rem;
  }

  .image {
    display: none;
  }

  .container .left-panel .content,
  .container .right-panel .content {
    margin-left: 40px;
  }

}
</style>
